const FloorPlanPlaceholderIcon = ({ viewBox = "0 0 64 64", className = "hayley-h-[84px] hayley-w-[84px] hayley-text-custom-4" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path
        d="M54.5 5.5H10.5C7.73858 5.5 5.5 7.73858 5.5 10.5V54.5C5.5 57.2614 7.73858 59.5 10.5 59.5H54.5C57.2614 59.5 59.5 57.2614 59.5 54.5V10.5C59.5 7.73858 57.2614 5.5 54.5 5.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.5 49.5L20.5 34.5L27.5 42.5L39.5 26.5L53.5 49.5H11.5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M24 25.5C27.0376 25.5 29.5 23.0376 29.5 20C29.5 16.9624 27.0376 14.5 24 14.5C20.9624 14.5 18.5 16.9624 18.5 20C18.5 23.0376 20.9624 25.5 24 25.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FloorPlanPlaceholderIcon;
